<div class=" min-h-100" style="min-width: 43vw !important;">
    <div class="flex flex-col">
        <div class="flex justify-between mb-1">
            <h3 class="site-name-color">{{dashboardService.translate('Select Date Range')}}</h3>
            <span class="flex items-center " mat-dialog-close mat-icon-button style="cursor: pointer">
            <mat-icon [svgIcon]="'custom:close'"></mat-icon>
        </span>
        </div>
    </div>
    <hr class="w-full my-4">
    <div class="flex justify-center flex-row w-full">
        <div class="w-full ">
            <div class="relative text-gray-600 focus-within:text-gray-400 rounded-2xl w-full min-w-4/5">
      <span class="absolute inset-y-0 right-0 flex items-center pl-2">
        <button class="p-1 focus:outline-none focus:shadow-outline">
          <mat-icon aria-hidden="false" aria-label="Example home icon">date_range</mat-icon>
        </button>
      </span>
                <input type="text" name="search"
                       [readOnly]="true"
                       class="shadow appearance-none border rounded rounded-2xl w-full py-3 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                       id="searchLocation" [placeholder]="dashboardService.translate('Select Date Range')"
                       [locale]="{applyLabel: 'ok', format: 'YYYY-MM-DD'}"
                       ngxDaterangepickerMd [(ngModel)]="shiftDataService.selectedDates"
                       [ranges]="defaultDateRanges"
                       [showCustomRangeLabel]="true"
                       [alwaysShowCalendars]="true"
                       [keepCalendarOpeningWithRange]="true"                       
                       [showClearButton]="true" (change)="onDateFilterChange($event)"
                       style="border-radius: 0.5rem !important;" #dateRangeInput>
            </div>
        </div>
    </div>
</div>
